import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { CRUISE_URL } from './constant/BaseApiUrl';

export default class CruiseManagement {
  getDestinationList() {
    return axios.get(`${CRUISE_URL}${ApiKey.MANAGE_CRUISE}/destinations`);
  }
  getCruiseLineList() {
    return axios.get(`${CRUISE_URL}${ApiKey.MANAGE_CRUISE}/lines`);
  }
  getCruiseShipList() {
    return axios.get(`${CRUISE_URL}${ApiKey.MANAGE_CRUISE}/ships`);
  }
  getSailingList() {
    return axios.get(`${CRUISE_URL}${ApiKey.MANAGE_CRUISE}/sailings`);
  }
  updateStatus(id, payload) {
    return axios.put(`${CRUISE_URL}${ApiKey.CRUISE}/${id}/status`, payload);
  }
}
